import React from "react";
import Calendar from "react-calendar";
import PropTypes from "prop-types";
import classNames from "classnames";
import dayjs from "dayjs";
import { ReactComponent as ArrowBack } from "../../../assets/img/arrowLeft.svg";
import { ReactComponent as ArrowForward } from "../../../assets/img/arrowRight.svg";

import "./CustomCalendar.scss";

const CustomCalendar = ({
  calendarHeader,
  dateValue,
  setDateValue,
  checkDisabledDates,
  minBookingDate,
  maxBookingDate,
  closeCalendar,
  submitCalendar,
  tileClassName,
  error,
  formatShortWeekday,
  onActiveStartDateChange,
  activeStartDate,
  disableActionButtons,
}) => {
  const navigationAriaLabel = dayjs().format("MMMM YYYY");

  return (
    <>
      <div
        className={classNames({
          "calendar-container": true,
          "calendar-container--error":
            error.present && (error.type === "calendar" || error.type === "smokeFirstEntrycalendar"),
        })}
      >
        <div className="calendar-header">
          <span>{calendarHeader ?? "Select a date"}</span>
        </div>

        <Calendar
          onChange={setDateValue}
          value={dateValue}
          tileDisabled={checkDisabledDates}
          view={"month"}
          activeStartDate={activeStartDate}
          minDate={minBookingDate}
          onActiveStartDateChange={onActiveStartDateChange}
          maxDate={maxBookingDate}
          navigationAriaLabel={navigationAriaLabel}
          prevLabel={<ArrowBack className="arrow" />}
          prev2Label={<></>}
          prevAriaLabel={"Previous"}
          nextLabel={<ArrowForward className="arrow" />}
          next2Label={<></>}
          nextAriaLabel={"Next"}
          tileClassName={tileClassName}
          formatShortWeekday={formatShortWeekday}
        />

        {!disableActionButtons && (
          <div className="calendar-footer">
            <button onClick={() => closeCalendar()}>Cancel</button>
            <button onClick={() => submitCalendar()} disabled={dateValue === undefined}>
              Ok
            </button>
          </div>
        )}
      </div>

      {error.present && error.type === "calendar" && (
        <div className="calendar-error-msg">
          <span>Press ok to confirm your appointment date</span>
        </div>
      )}
      {error.present && error.type === "smokeFirstEntrycalendar" && (
        <div className="calendar-error-msg">
          <span>Please select a date to continue</span>
        </div>
      )}
    </>
  );
};

CustomCalendar.propTypes = {
  tileClassName: PropTypes.func,
  onActiveStartDateChange: PropTypes.func,
  activeStartDate: PropTypes.string,
  disableActionButtons: PropTypes.bool,
  formatShortWeekday: PropTypes.func,
  calendarHeader: PropTypes.string,
  dateValue: PropTypes.instanceOf(Date),
  setDateValue: PropTypes.func.isRequired,
  checkDisabledDates: PropTypes.func.isRequired,
  maxBookingDate: PropTypes.instanceOf(Date).isRequired,
  closeCalendar: PropTypes.func.isRequired,
  submitCalendar: PropTypes.func.isRequired,
  error: PropTypes.object.isRequired,
};

export default CustomCalendar;
